"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TabsContext = require("./TabsContext");

var _TabsModule = _interopRequireDefault(require("./Tabs.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      tabsElements: []
    });

    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          positionCenter = _this$props.positionCenter,
          spaceBetween = _this$props.spaceBetween,
          className = _this$props.className,
          onTabChange = _this$props.onTabChange,
          marginRight = _this$props.marginRight,
          width = _this$props.width,
          maxWidth = _this$props.maxWidth,
          minWidth = _this$props.minWidth,
          sticky = _this$props.sticky;
      var classes = (0, _classnames.default)(_TabsModule.default.tabs, positionCenter && _TabsModule.default.positionCenter, spaceBetween && _TabsModule.default.spaceBetween, sticky && _TabsModule.default.sticky, className);

      var ActiveTabBorder = function ActiveTabBorder(_ref) {
        var activeTabElement = _ref.activeTabElement,
            children = _ref.children,
            restProps = _objectWithoutProperties(_ref, ["activeTabElement", "children"]);

        var style = {
          height: 2,
          backgroundColor: "#000",
          position: "absolute",
          bottom: -1,
          transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          willChange: "left, width"
        };

        if (activeTabElement) {
          style.width = activeTabElement.offsetWidth;
          style.left = activeTabElement.offsetLeft;
        }

        return _react.default.createElement("div", _extends({
          style: style
        }, restProps), children);
      };

      return _react.default.createElement(_TabsContext.TabProvider, {
        activeTab: this.props.activeTab
      }, _react.default.createElement(_TabsContext.TabConsumer, null, function (value) {
        if (onTabChange && value.context.prevActiveTab.id && value.context.prevActiveTab.id !== value.context.activeTab.id) {
          onTabChange(value.context.activeTab);
        }

        return _react.default.createElement("div", {
          className: classes
        }, _react.default.createElement("div", {
          className: _TabsModule.default.tabsContainer
        }, _react.default.createElement("ul", {
          className: _TabsModule.default.listTabs
        }, value.context.tabs.map(function (tab, index) {
          return _react.default.createElement("li", {
            style: {
              marginRight: marginRight,
              width: width,
              maxWidth: maxWidth,
              minWidth: minWidth
            },
            className: _TabsModule.default.tabsLi,
            key: index,
            id: tab.id,
            ref: function ref(tabElement) {
              if (!_this2.state.tabsElements[tab.id]) {
                _this2.setState(function (prevState, props) {
                  var tabsElements = prevState.tabsElements;
                  tabsElements[tab.id] = tabElement;
                  return {
                    tabsElements: tabsElements
                  };
                });
              }
            }
          }, _react.default.createElement("a", {
            className: (0, _classnames.default)(_TabsModule.default.tab, value.context.activeTab.id === tab.id && _TabsModule.default.active),
            href: "javascript:void(0)",
            onClick: value.context.onClick(tab),
            onKeyPress: function onKeyPress(event) {
              var code = event.keyCode || event.which;

              if (code === 13) {
                _this2.onClick(tab)(event);
              }
            }
          }, tab.title));
        })), _react.default.createElement(ActiveTabBorder, {
          activeTabElement: _this2.state.tabsElements[value.context.activeTab.id]
        })), _this2.props.children);
      }));
    }
  }]);

  return Tabs;
}(_react.default.Component);

Tabs.propTypes = {
  positionCenter: _propTypes.default.bool,
  spaceBetween: _propTypes.default.bool,
  sticky: _propTypes.default.bool
};
Tabs.defaultProps = {
  positionCenter: false,
  spaceBetween: false,
  sticky: false
};
var _default = Tabs;
exports.default = _default;